import ActionModel from '../models/ActionModel.js'
import {getColoredUseLine, getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'
import articleHelper from '../../helpers/articles-helper.js'

const ItemActionModel = {
  ...ActionModel,
  category: "item",
  isItem: true,
  increaseDangerMeterOnUse: 0, //don't allow items to affect Danger Meter
                              // (unless it is an actual Danger Meter boosting item (affectTargetDangerMeter)
  canMiss: false,
  canBeReplaced: false, //this is an assumption for all Items,
  // but you could toggle some to `true` in the future if needbe

  //Set up a buggedStep for items
  getBuggedStep(actionModel, casterModel, targetModels, descriptionObject) {



    return [
      getColoredUseLine(casterModel.id, actionModel.name, articleHelper(actionModel.name)),
      {
        type: "message",
        content: [
          `but it was BUGGED!`,
        ]
      }
    ]
  }

};

  //Items
export default {
  //Mini Battery Pack
  "item_mini-battery-pack": {
    ...ItemActionModel,
    name: "Mini Battery Pack",
    description: "Recovers 20 HP.",
    targetType: "single-ally",
    affectTargetHpPoints: 20,

    getValidity(actionModel, casterModel, targetModels) {
      const targetModel = targetModels[0];
      if (targetModel.hp === targetModel.maxHp) {
        return {
          isValid: false,
          invalidReasons: [`${targetModel.name}'s HP is full!`]
        }
      }
      return {
        isValid: true,
        invalidReasons: []
      };
    },


    getSuccessStep(actionModel, casterModel, targetModels, descriptionObject) {

      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` uses a ${actionModel.name}!`
        : ` hands out a ${actionModel.name}!`;

      const recoverAmount = descriptionObject.description.hpDamage[targetModel.id];

      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        { //Play the sound (animation)
          type: "animation",
          animationKey: "AnimationFillHp",
          animationData: {}
        },
        { //Play the state change!
          type: "stateChange",
          newCombatantState: descriptionObject.state,
          description: descriptionObject.description || {}
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            ` recovered ${recoverAmount} HP!`
          ]
        }
      ]
    }
  },

  //Mini PP Pack
  "item_mini-pp-pack": {
    ...ItemActionModel,
    name: "Mini PP Pack",
    description: "Recovers 20 PP.",
    targetType: "single-ally",
    affectTargetPpPoints: 20,
    getSuccessStep(actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false)
      ]
    },
    getValidity(actionModel, casterModel, targetModels) {
      const targetModel = targetModels[0];
      if (targetModel.pp === targetModel.maxPp) {
        return {
          isValid: false,
          invalidReasons: [`PP is full!`]
        }
      }
      return {
        isValid: true,
        invalidReasons: []
      };
    },
  },




  //Network Reset Code
  "item_network-reset-code": {
    ...ItemActionModel,
    name: "Network Reset Code",
    description: "Cures lagging.",
    targetType: "single-ally",
    affectTargetStatus: ["lag", "normal"],

    shouldFail: function (actionModel, casterModel, targetModels) {
      return (targetModels[0].status !== "lag");
    },
    getValidity(actionModel, casterModel, targetModels) {
      const targetModel = targetModels[0];
      if (targetModel.status !== "lag") {
        return {
          isValid: false,
          invalidReasons: [`${targetModel.name} is not lagging!`]
        }
      }
      return {
        isValid: true,
        invalidReasons: []
      };
    },
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false),
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s lagging has ended!`,
          ]
        }
      ]
    },
    getFailStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false),
        {
          type: "message",
          content: [
            `but it didn't do anything!`,
          ]
        }
      ]
    }
  },

  //Breakpoint
  "item_breakpoint": {
    ...ItemActionModel,
    name: "Breakpoint",
    description: "Patches a memory leak.",
    targetType: "single-ally",
    affectTargetStatus: ["memory-leak", "normal"],

    shouldFail: function (actionModel, casterModel, targetModels) {
      return (targetModels[0].status !== "memory-leak");
    },

    getValidity(actionModel, casterModel, targetModels) {
      const targetModel = targetModels[0];
      if (targetModel.status === "fire") {
        return {
          isValid: false,
          invalidReasons: [`Need something stronger to stop a fire!`]
        }
      }
      if (targetModel.status !== "memory-leak") {
        return {
          isValid: false,
          invalidReasons: [`${targetModel.name} does not have a memory leak!`]
        }
      }
      return {
        isValid: true,
        invalidReasons: []
      };
    },
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false),
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s memory leak is patched!`,
          ]
        }
      ]
    },
    getFailStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false),
        {
          type: "message",
          content: [
            `but it didn't do anything!`,
          ]
        }
      ]
    }
  },

  //STICKERS
  "item_attack-sticker-i": {
    ...ItemActionModel,
    name: "Attack Sticker I",
    description: "Increases attack stat for the rest of the battle.",
    targetType: "single-ally",
    affectTargetAttackModifier: 3,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` slaps on an ${actionModel.name}!`
        : ` hands out an ${actionModel.name}!`;
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s attack increased!`,
          ]
        }
      ]
    },
  },
  "item_defense-sticker-i": {
    ...ItemActionModel,
    name: "Defense Sticker I",
    description: "Increases defense stat for the rest of the battle.",
    targetType: "single-ally",
    affectTargetDefenseModifier: 3,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` slaps on a ${actionModel.name}!`
        : ` hands out a ${actionModel.name}!`;
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s defense increased!`,
          ]
        }
      ]
    },
  },
  "item_speed-sticker-i": {
    ...ItemActionModel,
    name: "Speed Sticker I",
    description: "Increases speed stat for the rest of the battle.",
    targetType: "single-ally",
    affectTargetSpeedModifier: 3,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` slaps on a ${actionModel.name}!`
        : ` hands out a ${actionModel.name}!`;
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s speed increased!`,
          ]
        }
      ]
    },
  },


  //REVIVE
  "item_revive": {
    ...ItemActionModel,
    name: "Revive Pack",
    description: "Bring a dead ally back to life!",
    targetType: "single-ally",
    targetMustBeDead: true,
    affectTargetHpPointsByPercent: 0.45, //% //Should this be POINTS based instead?

    shouldFail: function (actionModel, casterModel, targetModels) {
      return targetModels[0].isAlive(); //fail is combatant isAlive
    },

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a"),
        { //Play the sound (animation)
          type: "animation",
          animationKey: "AnimationFillHp",
          animationData: {}
        },
        { //Play the state change!
          type: "stateChange",
          newCombatantState: descriptionObject.state,
          description: descriptionObject.description || {}
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            ` is revived!`,
          ]
        }
      ]
    },
  },

  //FULL REVIVE
  "item_full-revive": {
    ...ItemActionModel,
    name: "Full Revive Pack",
    description: "Bring a dead ally back to life with 100% HP!",
    targetType: "single-ally",
    targetMustBeDead: true,
    affectTargetHpPointsByPercent: 1, //100%

    shouldFail: function (actionModel, casterModel, targetModels) {
      return targetModels[0].isAlive(); //fail is combatant isAlive
    },

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a"),
        { //Play the sound (animation)
          type: "animation",
          animationKey: "AnimationFillHp",
          animationData: {}
        },
        { //Play the state change!
          type: "stateChange",
          newCombatantState: descriptionObject.state,
          description: descriptionObject.description || {}
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            ` is revived!`,
          ]
        }
      ]
    },
  },


  //HONEYPOT TRAP
  "item_honeypot-trap": {
    ...ItemActionModel,
    name: "Honeypot Trap",
    description: "WARNING: explodes in your face! Use it to fool a Copy/Paster.",
    targetType: "only-me",
    affectTargetHpPoints: -7,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            ` opens a Honeypot Trap!`,
          ]
        },
        {
          type: "message",
          content: [
            `The Honeypot Trap blew up in `,
            getColoredNameById(targetModel.id),
            `'s face!!!`
          ]
        }
      ]
    },
  },

  //Danger Boost
  "item_danger-boost": {
    ...ItemActionModel,
    name: "Avg Danger Boost",
    description: "Boost a friendly Danger Meter by 60 percent!",
    targetType: "single-ally",
    affectTargetDangerMeter: 60,

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {

      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` uses an ${actionModel.name}!`
        : ` hands out an ${actionModel.name}!`;

      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s Danger Meter is boosted!`,
          ]
        }
      ]
    },
  },
  //Max Danger Boost
  "item_max-danger-boost": {
    ...ItemActionModel,
    name: "Max Danger Boost",
    description: "Fills a friendly Danger Meter to 100%!",
    targetType: "single-ally",
    affectTargetDangerMeter: 100,

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {

      const targetModel = targetModels[0];
      const firstMessage = casterModel.id === targetModel.id
        ? ` uses a ${actionModel.name}!`
        : ` hands out a ${actionModel.name}!`;

      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            firstMessage
          ]
        },
        {
          type: "message",
          content: [
            getColoredNameById(targetModel.id),
            `'s Danger Meter is now full!`,
          ]
        }
      ]
    },
  },
  //Team Danger Boost
  "item_team-danger-boost": {
    ...ItemActionModel,
    name: "Team Danger Boost",
    description: "Boost all friendly Danger Meters by 30 percent!",
    targetType: "ally-team",
    affectTargetDangerMeter: 30,

    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        getColoredUseLine(casterModel.id, actionModel.name, "a", false),
        {
          type: "message",
          content: [
            `Friendly Danger Meters are boosted!`,
          ]
        }
      ]
    },
  },

}


// WEBPACK FOOTER //
// ./src/battle/battle-data/_items.js